import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SuscripcionBoletin } from 'src/app/models/obs/suscripcionBoletin';
import { SuscripcionService } from 'src/app/services/obs/suscripcion.service';

declare var $: any;

@Component({
  selector: 'app-suscription',
  templateUrl: './suscription.component.html',
  styleUrls: ['./suscription.component.scss']
})
export class SuscriptionComponent implements OnInit {
  @ViewChild('formSuscriptionModal', { static: false }) formSuscriptionModal: ElementRef;

  formSubs: FormGroup;
  subscription: SuscripcionBoletin;
  showTerms: boolean = false;
  fechaActual: Date;
  tipoMensaje: 'success' | 'danger' | 'info';
  mensajeOperacion: string = '';
  showSubscriptionBox: boolean = true;

  constructor(
    private fb: FormBuilder,
    private sbsS: SuscripcionService
  ) { }

  ngOnInit() {
    this.getDate();
    this.createForm();
  }

  createForm() {
    this.formSubs = this.fb.group({
      name: ['', [Validators.required, Validators.pattern(/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/)]],
      lastname: ['', [Validators.required, Validators.pattern(/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/)]],
      surname: ['', [Validators.required, Validators.pattern(/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/)]],
      email: ['', [Validators.required, Validators.email]],
      subscribed: [false, Validators.requiredTrue],
      status: [0]
    });
  }

  campoNoValido(campo: string) {
    const campoControl = this.formSubs.get(campo);
    return campoControl !== null && campoControl !== undefined && campoControl.invalid && campoControl.touched;
  }

  actualizarMensaje(mensaje: string, tipo: 'success' | 'danger' | 'info') {
    this.mensajeOperacion = mensaje;
    this.tipoMensaje = tipo;

    // Configura el temporizador para limpiar el mensaje después de 3 segundos (ajusta según sea necesario)
    setTimeout(() => {
      this.limpiarMensaje();
    }, 3000);
  }

  limpiarMensaje() {
    this.mensajeOperacion = '';
  }

  onSubmit() {
    if (this.formSubs.valid) {
      this.formSubs.get('status').setValue(0);
      this.subscription = this.formSubs.value;
      this.sbsS.create(this.subscription).subscribe({
        next: res => {
          this.actualizarMensaje('Suscripción exitosa', 'success');
          this.limpiarCamposYCerrarModal();
        },
        error: err => {
          this.actualizarMensaje('Error al suscribirse', 'danger');
        }
      });
    } else {
      this.actualizarMensaje('Formulario no válido', 'danger');
    }
  }

  limpiarCamposYCerrarModal() {
    // Limpia los campos del formulario
    this.formSubs.reset();

    // Cierra el modal utilizando jQuery
    $(this.formSuscriptionModal.nativeElement).modal('hide');
  }

  get name() {
    return this.formSubs.get('name');
  }

  get lastname() {
    return this.formSubs.get('lastname');
  }

  get surname() {
    return this.formSubs.get('surname');
  }

  get email() {
    return this.formSubs.get('email');
  }

  get subscribed() {
    return this.formSubs.get('subscribed');
  }

  toggleTerms(event: Event) {
    event.stopPropagation(); // Detiene la propagacion del evento
    this.showTerms = !this.showTerms;
  }

  getDate() {
    this.fechaActual = new Date();
  }

  getAlertClass() {
    switch (this.tipoMensaje) {
      case 'success':
        return 'alert-success';
      case 'danger':
        return 'alert-danger';
      case 'info':
        return 'alert-info';
      default:
        return 'alert-info';
    }
  }

  closeSubscriptionBox() {
    this.showSubscriptionBox = false;
  }
}
